import OpenExamDietsPage from "./pages/member/OpenExamDietsPage";
import ExamDietExamsPage from "./pages/member/ExamDietExamsPage";
import MyExamApplicationsPage from "./pages/member/MyExamApplicationsPage";
import ExamApplicationDetailsPage from "./pages/member/ExamApplicationDetailsPage";
import MemberExamTimetablePage from "./pages/member/MemberExamTimetablePage";
import ExamCallsPage from "./pages/member/ExamCallsPage";
import MyExamCallApplicationsPage from "./pages/member/MyExamCallApplicationsPage";
import ExamPaymentProcessingPage from "./pages/member/ExamPaymentProcessingPage";
import ExamFinalizePage from "./pages/member/ExamFinalizePage";

import AdminExamsPage from "./pages/admin/AdminExamsPage";
import AdminExamCallsPage from "./pages/admin/AdminExamCallsPage";
import AdminExamDetailsPage from "./pages/admin/AdminExamDetailsPage";
import AdminExamDietDetailsPage from "./pages/admin/AdminExamDietDetailsPage";
import AdminCentersPage from "./pages/admin/AdminCentersPage";
import AdminCenterSlotsPage from "./pages/admin/AdminCenterSlotsPage";
import AdminGradingPage from "./pages/admin/AdminGradingPage";
import AdminExamCoursesPage from "./pages/admin/AdminExamCoursesPage";
import AdminExamCourseDetailsPage from "./pages/admin/AdminExamCourseDetailsPage";
import AdminExamSessionsPage from "./pages/admin/AdminExamSessionsPage";
import AdminExamSessionDetailsPage from "./pages/admin/AdminExamSessionDetailsPage";
import AdminSessionCardsPage from "./pages/admin/AdminSessionCardsPage";
import AdminSessionAttendanceListPage from "./pages/admin/AdminSessionAttendanceListPage";
import AdminExamAdmissionCardPage from "./pages/admin/AdminExamAdmissionCardPage";
import AdminAttendanceCardPage from "./pages/admin/AdminAttendanceCardPage";
import AdminDietAttendancePage from "./pages/admin/AdminDietAttendancePage";
import AdminApplicationCoursesPage from "./pages/admin/AdminApplicationCoursesPage";
import AdminCourseGradingPage from "./pages/admin/AdminCourseGradingPage";
import ExamAdmissionCardPage from "./pages/ExamAdmissionCardPage";

import ChapterExamApplicationsPage from "./pages/chapter/ChapterExamApplicationsPage";

import ExaminerDashboardPage from "./pages/examiner/ExaminerDashboardPage";
import ExaminerCourseResultsPage from "./pages/examiner/ExaminerCourseResultsPage";
import ExaminerDietGradingPage from "./pages/examiner/ExaminerDietGradingPage";

import ChiefDashboardPage from "./pages/chief/ChiefDashboardPage";
import ManageExaminersPage from "./pages/chief/ManageExaminersPage";
import ChiefAssignExaminersPage from "./pages/chief/ChiefAssignExaminersPage";
import ExaminerMyMarkingPage from "./pages/examiner/ExaminerMyMarkingPage";
import ExaminerMarkCoursePage from "./pages/examiner/ExaminerMarkCoursePage";
import ResultReviewPage from "./pages/chief/ResultReviewPage";
import ChiefExamsPage from "./pages/chief/ChiefExamsPage";
import ChiefExamDetailsPage from "./pages/chief/ChiefExamDetailsPage";
import ChiefDietGradingPage from "./pages/chief/ChiefDietGradingPage";
import AdminExamApplicationsPage from "./pages/admin/AdminExamApplicationsPage";
import AdminExamApplicationsExamPage from "./pages/admin/AdminExamApplicationsExamPage";
import AdminExamDietApplicationsPage from "./pages/admin/AdminExamDietApplicationsPage";
import AdminExamApplicationFormPage from "./pages/admin/AdminExamApplicationFormPage";

import ChiefModeratorDashboardPage from "./pages/chief-moderator/ChiefModeratorDashboardPage";
import ManageModeratorsPage from "./pages/chief-moderator/ManageModeratorsPage";
import AssignCoursesToModeratorsPage from "./pages/chief-moderator/AssignCoursesToModeratorsPage";
import ChiefModeratorResultsPage from "./pages/chief-moderator/ChiefModeratorResultsPage";

import ModeratorDashboardPage from "./pages/moderator/ModeratorDashboardPage";
import ModeratorCoursesPage from "./pages/moderator/ModeratorCoursesPage";

import ChairmanModerationPage from "./pages/chairman/ChairmanModerationPage";

export const examRoutes = [
  // ── Member ─────────────────────────────────────────────────────────────────
  {
    path: "/exams/calls",
    element: <ExamCallsPage />,
    roles: ["member", "fellow", "probationer", "graduate", "technician"],
  },
  {
    path: "/exams/calls/applications",
    element: <MyExamCallApplicationsPage />,
    roles: ["member", "fellow", "probationer", "graduate", "technician"],
  },
  {
    // OnePay redirects here after the exam fee is paid; polls until 'paid'.
    path: "/exams/payment-processing/:appId",
    element: <ExamPaymentProcessingPage />,
    roles: ["member", "fellow", "probationer", "graduate", "technician"],
  },
  {
    // Post-payment: pick center + papers/courses, then submit.
    path: "/exams/applications/:id/finalize",
    element: <ExamFinalizePage />,
    roles: ["member", "fellow", "probationer", "graduate", "technician"],
  },
  {
    path: "/exams/diets",
    element: <OpenExamDietsPage />,
    roles: ["member", "fellow", "probationer", "graduate", "technician"],
  },
  // The rest of the applicant's journey, open to every grade that can apply.
  //
  // These two were still `roles: ["member"]` while the diet list that links to
  // one and the applications list that links to the other were open to
  // probationers, graduates and technicians — so a probationer could see an
  // open diet and be refused the exams inside it.
  {
    path: "/exams/diets/:dietId",
    element: <ExamDietExamsPage />,
    roles: ["member", "fellow", "probationer", "graduate", "technician"],
  },
  {
    path: "/exams/applications",
    element: <MyExamApplicationsPage />,
    roles: ["member", "fellow", "probationer", "graduate", "technician"],
  },
  {
    // Open to every grade that can APPLY, not just members.
    //
    // It was `roles: ["member"]` while the list it belongs to, the admission
    // card and the timetable were all open to probationers, graduates and
    // technicians — so the people who sit most of these exams could reach
    // their card but not the application behind it.
    path: "/exams/applications/:id",
    element: <ExamApplicationDetailsPage />,
    roles: ["member", "fellow", "probationer", "graduate", "technician"],
  },
  {
    path: "/exams/applications/:id/card",
    element: <ExamAdmissionCardPage />,
    roles: ["member", "fellow", "probationer", "graduate", "technician"],
  },
  {
    path: "/exams/sessions/:sessionId/timetable",
    element: <MemberExamTimetablePage />,
    roles: ["member", "fellow", "probationer", "graduate", "technician"],
  },

  // ── Admin ──────────────────────────────────────────────────────────────────
  //
  // ACCESS CONTROL. `roles` alone was the whole gate here, so every admin could
  // reach every page in Exams & Grading by typing the URL — the sidebar hid the
  // links but hiding a link is not a gate. Each route now also names the
  // capability its page exercises, matching the middleware on the API
  // (see routes/exam/api.php) and the permissions in ExamPermissionSeeder.
  //
  // RequirePermission requires roles AND perms to BOTH pass, so where a page is
  // used by an office that is not `admin` — the Chief Examiner, a moderator —
  // that role is named here too, leaving the permission as the real gate.
  // super_admin bypasses both.
  {
    path: "/exams/admin/exam-calls",
    element: <AdminExamCallsPage />,
    roles: ["admin"],
    perms: ["exam.diet.access"],
  },
  {
    path: "/exams/admin/exams",
    element: <AdminExamsPage />,
    roles: ["admin"],
    perms: ["exam.access"],
  },
  {
    path: "/exams/admin/exams/:id",
    element: <AdminExamDetailsPage />,
    roles: ["admin"],
    perms: ["exam.access"],
  },
  {
    // Shows the diet AND the marks each examiner recorded, so it is gated on
    // grading rather than on merely reading a diet.
    path: "/exams/admin/exams/:id/diets/:dietId",
    element: <AdminExamDietDetailsPage />,
    roles: ["admin", "committee_examination_board.chairman"],
    perms: ["exam.grade.access"],
  },
  {
    path: "/exams/admin/exam-centers",
    element: <AdminCentersPage />,
    roles: ["admin"],
    perms: ["exam.center.access"],
  },
  {
    path: "/exams/admin/exam-center-slots",
    element: <AdminCenterSlotsPage />,
    roles: ["admin"],
    perms: ["exam.slot.access"],
  },
  {
    path: "/exams/admin/exam-grading",
    element: <AdminGradingPage />,
    roles: ["admin"],
    perms: ["exam.grade.access"],
  },
  {
    path: "/exams/admin/courses",
    element: <AdminExamCoursesPage />,
    roles: ["admin"],
    perms: ["exam.access"],
  },
  {
    path: "/exams/admin/courses/:id",
    element: <AdminExamCourseDetailsPage />,
    roles: ["admin"],
    perms: ["exam.access"],
  },
  // ── Exam Sessions (shared timetable across all exams) ────────────────────
  {
    path: "/exams/admin/sessions",
    element: <AdminExamSessionsPage />,
    roles: ["admin"],
    perms: ["exam.access"],
  },
  {
    path: "/exams/admin/sessions/:sessionId",
    element: <AdminExamSessionDetailsPage />,
    roles: ["admin"],
    perms: ["exam.access"],
  },
  {
    path: "/exams/admin/sessions/:sessionId/cards",
    element: <AdminSessionCardsPage />,
    roles: ["admin"],
    perms: ["exam.access"],
  },
  {
    path: "/exams/admin/sessions/:sessionId/attendance",
    element: <AdminSessionAttendanceListPage />,
    roles: ["admin"],
    perms: ["exam.access"],
  },
  // Applications, browsed per exam then per diet.
  {
    path: "/exams/admin/applications",
    element: <AdminExamApplicationsPage />,
    roles: ["admin"],
    perms: ["exam.access"],
  },
  {
    path: "/exams/admin/applications/exams/:examId",
    element: <AdminExamApplicationsExamPage />,
    roles: ["admin"],
    perms: ["exam.access"],
  },
  {
    path: "/exams/admin/applications/exams/:examId/diets/:dietId",
    element: <AdminExamDietApplicationsPage />,
    roles: ["admin"],
    perms: ["exam.access"],
  },
  {
    path: "/exams/admin/applications/:id/form",
    element: <AdminExamApplicationFormPage />,
    roles: ["admin"],
    perms: ["exam.access"],
  },
  {
    path: "/exams/admin/applications/:id/card",
    element: <AdminExamAdmissionCardPage />,
    roles: ["admin"],
    perms: ["exam.access"],
  },
  {
    path: "/exams/admin/applications/:id/attendance-card",
    element: <AdminAttendanceCardPage />,
    roles: ["admin"],
    perms: ["exam.access"],
  },
  {
    path: "/exams/admin/exams/:id/diets/:dietId/attendance",
    element: <AdminDietAttendancePage />,
    roles: ["admin"],
    perms: ["exam.access"],
  },
  {
    // Decides which courses a candidate is registered to sit.
    path: "/exams/admin/applications/:id/courses",
    element: <AdminApplicationCoursesPage />,
    roles: ["admin"],
    perms: ["exam.application.manage"],
  },
  {
    // Records marks, and carries the emergency override that bypasses the
    // three-examiner average — hence exam.grade.manage, not grade.access.
    path: "/exams/admin/applications/:id/course-grading",
    element: <AdminCourseGradingPage />,
    roles: ["committee_examination_board.chairman", "super_admin"],
    perms: ["exam.grade.manage"],
  },

  // ── Examiner ───────────────────────────────────────────────────────────────
  {
    path: "/exams/examiner",
    element: <ExaminerDashboardPage />,
    roles: ["examiner"],
    perms: ["exam.marking"],
  },
  {
    path: "/exams/examiner/marking",
    element: <ExaminerMyMarkingPage />,
    roles: ["examiner", "committee_examination_board", "committee_examination_board.chairman"],
    perms: ["exam.marking"],
  },
  {
    path: "/exams/examiner/mark/:dietId/:courseId",
    element: <ExaminerMarkCoursePage />,
    roles: ["examiner", "committee_examination_board", "committee_examination_board.chairman"],
    perms: ["exam.marking"],
  },
  {
    path: "/exams/examiner/courses/:courseId/diet/:dietId",
    element: <ExaminerCourseResultsPage />,
    roles: ["admin", "committee_examination_board.chairman"],
    perms: ["exam.grade.access"],
  },
  {
    // Despite the URL this is the diet-level grading board, and it can release
    // (publish) the diet — so it takes the publishing permission.
    path: "/exams/examiner/exams/:id/diets/:dietId",
    element: <ExaminerDietGradingPage />,
    roles: ["admin", "examiner", "committee_examination_board.chairman"],
    perms: ["exam.result.publish"],
  },

  // ── Chief Examiner ─────────────────────────────────────────────────────────
  {
    path: "/exams/chief",
    element: <ChiefDashboardPage />,
    roles: ["committee_examination_board.chairman"],
    perms: ["exam.access"],
  },
  {
    path: "/exams/chief/exams",
    element: <ChiefExamsPage />,
    roles: ["committee_examination_board.chairman"],
    perms: ["exam.access"],
  },
  {
    path: "/exams/chief/exams/:id",
    element: <ChiefExamDetailsPage />,
    roles: ["committee_examination_board.chairman"],
    perms: ["exam.access"],
  },
  {
    // Creates user accounts and grants them the examiner role.
    path: "/exams/chief/examiners",
    element: <ManageExaminersPage />,
    roles: ["committee_examination_board.chairman"],
    perms: ["exam.examiner.assign"],
  },
  {
    path: "/exams/chief/assign-courses",
    element: <ChiefAssignExaminersPage />,
    roles: ["committee_examination_board.chairman"],
    perms: ["exam.examiner.assign"],
  },
  {
    path: "/exams/chief/diets/:dietId/assign-courses",
    element: <ChiefAssignExaminersPage />,
    roles: ["committee_examination_board.chairman"],
    perms: ["exam.examiner.assign"],
  },
  {
    path: "/exams/chief/diets/:dietId/grading",
    element: <ChiefDietGradingPage />,
    roles: ["committee_examination_board.chairman"],
    perms: ["exam.grade.access"],
  },
  {
    path: "/exams/chief/review",
    element: <ResultReviewPage />,
    roles: ["committee_examination_board.chairman"],
    perms: ["exam.grade.access"],
  },

  // ── Chief Moderator ────────────────────────────────────────────────────────
  // `roles: ["admin"]` alone locked the actual chief_moderator out of their own
  // board — the sidebar lists these under the admin section, but the people who
  // do the work hold the moderator roles. Both are named so the permission is
  // what decides.
  {
    path: "/exams/chief-moderator",
    element: <ChiefModeratorDashboardPage />,
    roles: ["admin", "chief_moderator"],
    perms: ["exam.moderation.access"],
  },
  {
    path: "/exams/chief-moderator/moderators",
    element: <ManageModeratorsPage />,
    roles: ["admin", "chief_moderator"],
    perms: ["exam.moderation.manage"],
  },
  {
    path: "/exams/chief-moderator/assign-courses",
    element: <AssignCoursesToModeratorsPage />,
    roles: ["admin", "chief_moderator"],
    perms: ["exam.moderation.manage"],
  },
  {
    path: "/exams/chief-moderator/results",
    element: <ChiefModeratorResultsPage />,
    roles: ["admin", "chief_moderator"],
    perms: ["exam.moderation.access"],
  },

  // ── Moderator ──────────────────────────────────────────────────────────────
  {
    path: "/exams/moderator",
    element: <ModeratorDashboardPage />,
    roles: ["admin", "moderator", "chief_moderator"],
    perms: ["exam.moderation.access"],
  },
  {
    path: "/exams/moderator/courses",
    element: <ModeratorCoursesPage />,
    roles: ["admin", "moderator", "chief_moderator"],
    perms: ["exam.moderation.access"],
  },

  // ── Chairman of Moderation Board ───────────────────────────────────────────
  {
    path: "/exams/chairman/moderation",
    element: <ChairmanModerationPage />,
    roles: ["admin", "chief_moderator"],
    perms: ["exam.moderation.access"],
  },

  // ── Chapter endorsement ────────────────────────────────────────────────────
  // The scope comes off the leader's own leadership record on the server, so
  // the role gate is all this needs.
  {
    path: "/chapter/exam-applications",
    element: <ChapterExamApplicationsPage />,
    roles: ["chapter_chairman", "chapter_secretary"],
  },

  // The Membership Committee's exam decision screen was removed on 2026-09-13
  // along with the rung it served — the secretariat approves or rejects an exam
  // application itself. The committee still reviews upgrades, entries and
  // firms; only exams left.
];
